import { useState } from 'react';
import { css, type Theme } from '@emotion/react';

import { makeStyles } from '@toolbox/style';
import { Box, Text } from '@toolbox/components';
import { CloseIcon } from '@toolbox/components/Icon/icons/CloseIcon';
import { ValuationIcon } from '@toolbox/components/Icon/icons/ValuationIcon';
import { useMarketTrends } from '@widget/core';
import { richTextResolver } from '../../storyblok/rteResolver';
import { replaceVariablesInSocialProof } from './replaceVariablesInSocialProof';
import { richTextIsEmpty } from '@widget/utils/richTextIsEmpty';

import type { FC } from 'react';
import type { Richtext } from 'storyblok-js-client';

export type SocialProofProps = {
  message?: Richtext;
  mode?: 'default' | 'mini';
};

const useStyles = makeStyles(({ theme }) => ({
  socialProof: css`
    background-color: ${theme.palette.colors.primary};
    color: ${theme.palette.colors.white};
    padding: 12px 18px;
    margin: 1rem 0;
    margin-right: auto;
    display: flex;
    align-items: flex-start;
    column-gap: 16px;
    span {
      display: inline-block;
    }
    p {
      font-size: 13px;
      margin: 0;
    }
  `,
  socialProofMini: css`
    margin: 0;
  `,
  message: css`
    color: ${theme.palette.colors.white};

    p {
      color: ${theme.palette.colors.white};
    }
  `,
  iconStyle: (theme: Theme) => css`
    flex: 0 0 20px;
    height: 23px;
    ${theme.media.down('sm')} {
      width: 28px;
      height: 30px;
      margin-top: 6px;
    }
  `,
  closeStyle: (theme: Theme) => css`
    flex: 0 0 12px;
    height: 23px;
    cursor: pointer;
    margin-left: auto;
    ${theme.media.down('sm')} {
      height: 12px;
      margin-top: 6px;
    }
  `,
}));

export const SocialProof: FC<SocialProofProps> = ({ message, mode = 'default' }) => {
  const classes = useStyles();
  const [isClosed, setIsClosed] = useState(false);
  const { marketTrends } = useMarketTrends();

  if (isClosed || !message || richTextIsEmpty(message)) return <></>;

  const messageWithVariables = replaceVariablesInSocialProof(message, marketTrends);
  const htmlMessage = richTextResolver.render(messageWithVariables);

  return (
    <>
      <Box css={[classes.socialProof, mode === 'mini' && classes.socialProofMini] as any[]}>
        <ValuationIcon css={classes.iconStyle as any} />
        <Text variant="c1">
          <div css={classes.message as any} dangerouslySetInnerHTML={{ __html: htmlMessage }} />
        </Text>
        <CloseIcon onClick={() => setIsClosed(true)} css={classes.closeStyle as any} />
      </Box>
    </>
  );
};
